
import {getBet} from '../api/getBet';
import { setGetBetAction } from '../action';

export const setGetBet = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getBet(params);
            if (data.status === 'success') {
                dispatch(setGetBetAction({
                    data: data.data,
                    count: data.count
                }));           
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}